export const ResponseStatusCodes = {
  OK: 200,
  CREATED: 201,
  ACCEPTED: 202,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  NOT_ACCEPTABLE: 406,
  INVALID_BODY: 422,
  TOO_MANY_REQUESTS: 429,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
  BAD_GATEWAY: 502,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  NEED_VERIFICATION: 1102,
  ON_VERIFICATION: 1103,
  BANNED: 1011,
  REMOVED: 1012,
  DEACTIVATED: 1013,
  VALIDATION_ERROR: 1002,
} as const

export type ResponseStatusCodes = (typeof ResponseStatusCodes)[keyof typeof ResponseStatusCodes]
